"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Yup = __importStar(require("yup"));
var lodash_1 = __importDefault(require("lodash"));
var objectHelper_1 = require("../helpers/objectHelper");
var GeneralSettings_1 = require("../constants/GeneralSettings");
Yup.addMethod(Yup.object, 'addressPicker', function (message) {
    return this.test('addressPicker', message, function (value) {
        return !!(value === null || value === void 0 ? void 0 : value.addressData);
    });
});
Yup.addMethod(Yup.mixed, 'requiredIf', function (message, requiredFields, path) {
    var condition = lodash_1.default.get(requiredFields, path);
    if (condition === undefined) {
        return this;
    }
    if (condition === true) {
        return this.required(message);
    }
    return this.test('requiredIf', message, function (value, context) {
        var c = context.from[1].value;
        var v = lodash_1.default.get(c, condition.path);
        if (v !== condition.value) {
            return true;
        }
        return !!value;
    });
});
Yup.addMethod(Yup.mixed, 'requiredByDealType', function (message, dealType) {
    return this.test('requiredByDealType', message, function (value, context) {
        return ((!lodash_1.default.isUndefined(value) && !lodash_1.default.isNull(value)) ||
            context.from[1].value.deal !== dealType);
    });
});
Yup.addMethod(Yup.mixed, 'validateDeveloperApartmentAvailability', function (message, dealType, apartmentId) {
    return this.test('validateDeveloperApartmentAvailability', message, function (value, context) {
        if (context.parent.id === apartmentId) {
            return ((!lodash_1.default.isUndefined(value) && !lodash_1.default.isNull(value)) ||
                context.from[1].value.deal !== dealType);
        }
        else {
            return true;
        }
    });
});
Yup.addMethod(Yup.mixed, 'requiredByPropertyType', function (message, structureType) {
    return this.test('requiredByPropertyType', message, function (value, context) {
        return ((!lodash_1.default.isUndefined(value) && !lodash_1.default.isNull(value)) ||
            !structureType.includes(context.from[1].value.initial_info.property_type));
    });
});
Yup.addMethod(Yup.mixed, 'validateDeveloperApartmentByStructureType', function (message, structureType, apartmentId) {
    return this.test('validateDeveloperApartmentByStructureType', message, function (value, context) {
        if (context.parent.id === apartmentId) {
            return ((!lodash_1.default.isUndefined(value) && !lodash_1.default.isNull(value)) ||
                !structureType.includes(context.from[1].value.initial_info.property_type));
        }
        else {
            return true;
        }
    });
});
Yup.addMethod(Yup.mixed, 'validateCurrentApartment', function (message, apartmentId) {
    return this.test('validateCurrentApartment', message, function (value, context) {
        if (context.parent.entity_id === apartmentId) {
            return ((!lodash_1.default.isUndefined(value) && !lodash_1.default.isNull(value)) || !!value);
        }
        return true;
    });
});
Yup.addMethod(Yup.string, 'website', function (message) {
    var websiteRegex = /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
    return this.test('website', message, function (value) {
        if (value) {
            return websiteRegex.test(value);
        }
        return true;
    });
});
Yup.addMethod(Yup.string, 'armPhone', function (message) {
    var armPhoneRegex = /^([374]{4}|[0]{1})?([1-9]{5})(\d{6})$/;
    return this.test('armPhone', message, function (value) {
        if (value) {
            return armPhoneRegex.test(value);
        }
        return true;
    });
});
Yup.addMethod(Yup.string, 'password', function (message) {
    var passwordRegex = /^(?=\S*[[aA-zZ\s])(?=\S*[[aA-zZ\s])(?=\S*\d)(?=\S*[^\w\s])\S[\u0000-\u007f]{7,}$/;
    return this.test('password', message, function (value) {
        if (value) {
            return passwordRegex.test(value);
        }
        return true;
    });
});
Yup.addMethod(Yup.array, 'unique', function (message, path, key) {
    return this.test('unique', message, function (values) {
        if (values === void 0) { values = []; }
        var index = objectHelper_1.findFirstDuplicateIndex(values, function (v) { return v[key]; });
        if (index > -1) {
            return this.createError({
                path: path + "[" + index + "]." + key,
                message: message,
            });
        }
        return true;
    });
});
Yup.addMethod(Yup.array, 'requiredAtLeastOnePhoneNumber', function (message) {
    return this.test('requiredAtLeastOnePhoneNumber', message, function (values) {
        if (values === void 0) { values = []; }
        return (values.filter(function (e) { return e.phone && e.phone.length > 0; }).length > 0);
    });
});
Yup.addMethod(Yup.array, 'requiredBuildingPicture', function (errorMessage) {
    return this.test("requiredBuildingPicture", errorMessage, function (value) {
        var _a = this, path = _a.path, createError = _a.createError;
        var isPicture = value === null || value === void 0 ? void 0 : value.some(function (item) {
            return item.building_media_type ===
                GeneralSettings_1.BUILDING_MEDIA_TYPES.BUILDING_PICTURES;
        });
        if (!isPicture) {
            return createError({ path: path, message: errorMessage });
        }
        return true;
    });
});
